import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    REPORTUSAGEBUTTON,
} from 'src/constants/productConstants';

const useInitReportUsageEffect = ({
  isSubmitClicked,
  myCaseResourceType,
  restrictReviewScreen,
  setPhysicianDropdown,
  physicianDropdownValue,
  setProcedureDropdown,
  procedureValue,
  setProcedureData,
  procedureData,
  setPriceOverrideReason,
  storedPriceOverrideReason,
  setPricingNotes,
  storedPricingNotes,
  footerButtonStatuses,
  getModifiedButtonVisibilities,
  replenish,
  currentActivity,
  REPORTPROGRESSTEPS,
  usageDetails,
  storedItemTableData,
  t,
  procedurePageVisibility,
  submit,
  review,
  setFooterButtonStatuses,
  isConfirmationChecked,
  itemTableData,
  getReplenNonTissueItems,
  replenDetails,
  setReplenGridData,
  getTotalQuantity,
  storedUnidSurgeryData,
  setUnidSurgeryInfo,
  setReportUsageFormObj,
  reportUsageObject,
  setReplenRPGridData,
  replenishmentPageVisibilityUsage,
  procedure,
  showReportPayment,
  getFooterButtonLabel
}) => {
  useEffectWithErrorLogging(() => {
        if (
            !isSubmitClicked &&
            myCaseResourceType !== 'reportPayment' &&
            restrictReviewScreen
        ) {
            setPhysicianDropdown(physicianDropdownValue);
            setProcedureDropdown(procedureValue);
            setProcedureData(procedureData);
            setPriceOverrideReason(storedPriceOverrideReason);
            setPricingNotes(storedPricingNotes);
            let modifiedButtonStatuses = [...footerButtonStatuses];
            modifiedButtonStatuses = getModifiedButtonVisibilities(
                myCaseResourceType,
                footerButtonStatuses,
                replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review,
                showReportPayment && currentActivity === REPORTPROGRESSTEPS[2]
                    ? review
                    : currentActivity === REPORTPROGRESSTEPS?.[2] &&
                      usageDetails &&
                      usageDetails.unidId &&
                      storedItemTableData?.some((item) => {
                          return (
                              item?.cfn?.startsWith('B33') ||
                              item.children?.some((product) =>
                                  product?.cfn?.startsWith('B33')
                              )
                          );
                      })
                    ? t('reportUsage.progressBar.UNiDInfo')
                    : getFooterButtonLabel(currentActivity),
                true
            );
            setFooterButtonStatuses(
                modifiedButtonStatuses.map((x) =>
                    x.btnName === submit &&
                        x.btnVisibility &&
                        isConfirmationChecked
                        ? { ...x, isBtnDisable: false }
                        : x
                )
            );
            const productList =
                itemTableData && itemTableData.length > 0
                    ? itemTableData.filter((item) => item !== undefined)
                    : [];
            const productsList = getReplenNonTissueItems(productList);
            if (productsList.length > 0 && replenDetails.length > 0) {
                var productsListData = [];
                productsListData = productsList.map((product) => {
                    let replenIndex = replenDetails.findIndex(
                        (replenData) => replenData.unqId === product.unqId
                    );
                    return replenIndex === -1
                        ? product
                        : !replenDetails[replenIndex].accountOwned
                            ? {
                                ...product,
                                shippingDetails:
                                    replenDetails[replenIndex].shippingDetails,
                                newReplenQty:
                                    replenDetails[replenIndex].newReplenQty,
                                replenQty: replenDetails[replenIndex].replenQty,
                            }
                            : product;
                });
                const validatedItemTableData = productsListData;

                if (validatedItemTableData) {
                    if (
                        validatedItemTableData &&
                        validatedItemTableData.length > 0
                    ) {
                        setReplenGridData(
                            validatedItemTableData.map((item) => ({
                                ...item,
                                cfn: item.cfn,
                                isSelected: true,
                                isExcludedItem: item.isExcludedItem
                                    ? true
                                    : false,
                                accountOwned: item.accountOwned ? true : false,
                                replenQty: getTotalQuantity(item.lotSerial)
                                    ? getTotalQuantity(item.lotSerial)
                                    : item.replenQty,
                            }))
                        );
                    }
                }
            }
            storedUnidSurgeryData && setUnidSurgeryInfo(storedUnidSurgeryData);
            setReportUsageFormObj(reportUsageObject);
        }
        if (myCaseResourceType === 'reportPayment') {
            setPriceOverrideReason(reportUsageObject.overridenReason);
            setPricingNotes(reportUsageObject.pricingNotes);
            setReplenRPGridData(replenDetails);
            setReportUsageFormObj(reportUsageObject);
        }
    }, [showReportPayment, replenishmentPageVisibilityUsage, procedurePageVisibility]);
};

export default useInitReportUsageEffect;